export default __webpack_public_path__ + "static/media/img-15.b83c5515.jpg";